import React from 'react';
import CustomDatePicker from '@shared/components/CustomDatePicker';
import DatePickerArrowWrapper from '@shared/components/DatePickerArrowWrapper';
import { getToday } from '@shared/services/dateService';
import moment from 'moment';

/**
 * @typedef {object} MonthlyDatePickerProps
 * @property {*} [selectedDate]
 * @property {(selectedDate: Date) => void} [setSelectedDate]
 */

/**
 * @param {MonthlyDatePickerProps} props
 */
const MonthlyDatePicker = props => {
  const { selectedDate, setSelectedDate } = props;

  const today = getToday();
  const isLeftArrowDisabled = moment(today).isSameOrAfter(moment(selectedDate).startOf('month'));

  const handleLeftArrowClick = () => {
    setSelectedDate(addMonths(selectedDate, -1));
  };

  const handleRightArrowClick = () => {
    setSelectedDate(addMonths(selectedDate, 1));
  };

  const addMonths = (date, months) => {
    const newDate = new Date(date.getFullYear(), date.getMonth() + months, 1);
    return newDate < today ? today : newDate;
  };

  const setDate = date => {
    if (!date) {
      return;
    }
    setSelectedDate(date);
  };

  return (
    <DatePickerArrowWrapper
      handleLeftArrowClick={handleLeftArrowClick}
      handleRightArrowClick={handleRightArrowClick}
      isLeftArrowDisabled={isLeftArrowDisabled}>
      <CustomDatePicker
        id='date-picker'
        minDate={today}
        selectedDate={selectedDate}
        setSelectedDate={setDate}
        dateFormat='MM/yyyy'
      />
    </DatePickerArrowWrapper>
  );
};

export default MonthlyDatePicker;
